"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurationService = void 0;
class CurationService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * get curation field metadata
     * @returns CurationFieldsMetadataResponse
     * @throws ApiError
     */
    getCurationFieldMetadata() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/curation/metadata',
        });
    }
    /**
     * submit curtion query
     * @param requestBody
     * @returns CurationQueryResponse
     * @throws ApiError
     */
    submitCurationQuery(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/curation/query',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.CurationService = CurationService;
